import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String, endpoint: String, refresh: Boolean }

  async copy() {
    await this.writeText(this.textValue)

    const headers = { "Accept": "application/json" }
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
    if (csrfToken) headers["X-CSRF-Token"] = csrfToken

    const response = await fetch(this.endpointValue, {
      method: "POST",
      headers
    })

    if (!response.ok) throw new Error("Could not record copied link")

    this.element.setAttribute("aria-label", "Copied")

    if (this.refreshValue) window.location.reload()
  }

  async writeText(text) {
    if (navigator.clipboard?.writeText) {
      try {
        await navigator.clipboard.writeText(text)
        return
      } catch (_error) {
        // Fall through for browsers that expose the API but deny clipboard access.
      }
    }

    const input = document.createElement("textarea")
    input.value = text
    input.setAttribute("readonly", "")
    input.style.position = "fixed"
    input.style.opacity = "0"
    document.body.appendChild(input)
    input.select()

    const copied = document.execCommand("copy")
    input.remove()

    if (!copied) throw new Error("Could not copy link")
  }
}
